







import { Component, Vue } from 'vue-property-decorator';

import HeaderNavigationComponent from '@/components/HeaderNavigation.vue';

@Component({
  components: {
    HeaderNavigationComponent,
  },
})
export default class ApplicationComponent extends Vue {
  metaInfo() {
    return {
      title: this.$t('comapny.name'),
      meta: [
        { name: 'description', content: 'Epiloge is about connecting in your field of interest. Our vision is to help people share their knowledge, work, projects, papers and ideas and build their network through what they do rather where they live, study or work.' },
        { property: 'og:title', content: 'Epiloge - Build your network in your field of interest' },
        { property: 'og:site_name', content: 'Epiloge' },
        { property: 'og:type', content: 'website' },
        { name: 'robots', content: 'index,follow' },
      ],
    };
  }
}
